<glxy-page [pagePadding]="false" [mobileMaxWidth]="0">
  <glxy-page-toolbar>
    <glxy-page-title>
      <span>{{ 'INBOX.HEADER.INBOX_AI_TITLE' | translate }}</span>
      <mat-icon
        [glxyTooltip]="'INBOX.CHAT.AI_INFO' | translate"
        [highContrast]="false"
        [tooltipTitle]="'INBOX.CHAT.AI_INFO_TITLE' | translate"
        class="info-icon"
      >
        info_outline
      </mat-icon>
      <glxy-badge class="hide-on-mobile beta-badge" color="blue-solid">
        {{ 'INBOX.HEADER.BETA' | translate }}
      </glxy-badge>
    </glxy-page-title>
    <glxy-page-actions class="inbox-actions">
      <button mat-icon-button class="menu-icon close" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <inbox-ai-chat></inbox-ai-chat>
</glxy-page>
